module.exports = __webpack_public_path__ + "media/images/share-send-9d9b020c80e74f174277f15dc407b503.svg";